import { render, staticRenderFns } from "./livenoticeList.vue?vue&type=template&id=42b7daa2&scoped=true"
import script from "./livenoticeList.vue?vue&type=script&lang=js"
export * from "./livenoticeList.vue?vue&type=script&lang=js"
import style0 from "./livenoticeList.vue?vue&type=style&index=0&id=42b7daa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b7daa2",
  null
  
)

export default component.exports